import {Multiselect} from "../../../../../../components/form/multiselect/multiselect";
import {useTranslation} from "react-i18next";
import {useRef} from "react";
import {useOutsideClickHandler} from "../../../../../../utils/use-outside-click-handler";

type InputProps = {
    popoverItems: { key: string; label: string; value: number }[]
    popoverDate?: string
    setSpIdsToBulkChange: (spIds: number[]) => void
    setIsPopupOpen: (isOpen: boolean) => void
    spName?: string | null
    onPopoverAction?: (itemIds: number[]) => void
    spIdsToBulkChange: number[]
}

export const TimeChangePopup = ({ popoverItems, popoverDate, setSpIdsToBulkChange, setIsPopupOpen, spName, onPopoverAction, spIdsToBulkChange }: InputProps) => {
    const { t } = useTranslation()

    const popupRef = useRef(null)
    useOutsideClickHandler(popupRef, () => setIsPopupOpen(false))

    return (
        <div className="BulkChangePopup" ref={popupRef}>
            <div className="BulkChangePopup__container">
              <span className="BulkChangePopup__title">
                {t('all_jobs.copy_changes_to_more_ogs_on')} <strong>{popoverDate}</strong>:
              </span>
                <Multiselect
                    className="BulkChangePopup__select"
                    label={t('all_jobs.select_ogs_to_apply')}
                    onChange={values => {
                        const modifiedValues = values.map(itemValue => Number(itemValue))
                        setSpIdsToBulkChange(modifiedValues)
                    }}
                    options={popoverItems}
                    preselectAll
                />
                <div className="BulkChangePopup__controls">
                    <button onClick={() => setIsPopupOpen(false)} className="BulkChangePopup__secondary">
                        {t('all_jobs.apply_to_sp_only', { spName })}
                    </button>
                    <button
                        onClick={() => {
                            if (onPopoverAction) {
                                onPopoverAction(spIdsToBulkChange)
                            }

                            setIsPopupOpen(false)
                        }}
                        className="BulkChangePopup__primary"
                    >
                        {t('all_jobs.bulk_apply')}
                    </button>
                </div>
            </div>
        </div>
    )
}